let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5v6is")).then(() => parcelRequire('3KUUd'));